import { AppShell } from "@/components/app-shell"
import { DeviceList } from "@/components/devices/device-list"
import { NewDeviceDialog } from "@/components/devices/new-device-dialog"
import type { Device } from "@/types/device"

interface DevicesIndexProps {
  devices: Device[]
}

export default function DevicesIndex({ devices }: DevicesIndexProps) {
  return (
    <AppShell title="Devices" action={<NewDeviceDialog showTrigger />}>
      <div className="px-4 lg:px-6">
        <DeviceList devices={devices} />
      </div>
    </AppShell>
  )
}
